import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { HeroSection } from "@/components/home/HeroSection";
import { CategoriesSection } from "@/components/home/CategoriesSection";
import { FeaturedProviders } from "@/components/home/FeaturedProviders";
import { HowItWorks } from "@/components/home/HowItWorks";
import { PricingPreview } from "@/components/home/PricingPreview";
import { TestimonialsSection } from "@/components/home/TestimonialsSection";
import { CTASection } from "@/components/home/CTASection";
import { AdSenseUnit } from "@/components/ads/AdSenseUnit";
import { SEOHead } from "@/components/seo/SEOHead";
import { MainStructuredData } from "@/components/seo/StructuredData";

const Index = () => {
  const homepageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Wellness Connect - Book Wellness Services Online",
    description:
      "Simple online wellness booking platform. Find and book spa, massage, yoga, fitness, and holistic wellness services worldwide.",
    url: "https://wellnessconnect.com/",
    isPartOf: {
      "@type": "WebSite",
      name: "Wellness Connect",
      url: "https://wellnessconnect.com",
    },
    about: {
      "@type": "Thing",
      name: "Massage and Wellness Services",
    },
  };

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Book Wellness Services Online"
        description="Discover top-rated spas, massage, yoga, and fitness worldwide. Book wellness services online with debit or credit card. Trusted by thousands."
        keywords="wellness, spa, massage, yoga, fitness, book wellness online, massage services, wellness booking platform"
        canonicalUrl="/"
        structuredData={homepageSchema}
      />
      <MainStructuredData />
      <Navbar />
      <main>
        <HeroSection />
        <CategoriesSection />
        <FeaturedProviders />
        <HowItWorks />
        <PricingPreview />
        <AdSenseUnit />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
